
export default class CourseResultsFilter {
    private finalExamDone: boolean = false;
    private unconfirmed: boolean = false;
    private minimumCompleted: boolean = false;

    asQueryString() {
        return `finalExamDone=${this.finalExamDone}`
            + `&unconfirmed=${this.unconfirmed}`
            + `&minimumCompleted=${this.minimumCompleted}`;
    }

    readFromRaw(rawObject: any): CourseResultsFilter {
        this.finalExamDone = this.isTrue(rawObject['finalExamDone']);
        this.unconfirmed = this.isTrue(rawObject['unconfirmed']);
        this.minimumCompleted = this.isTrue(rawObject['minimumCompleted']);
        return this;
    }

    private isTrue(value: any) {
        return value === true || value === 'true';
    }

    isFinalExamDone(): boolean {
        return this.finalExamDone;
    }

    isMinimumCompleted(): boolean {
        return this.minimumCompleted;
    }

    isUnconfirmed(): boolean {
        return this.unconfirmed;
    }

}
